import React, { useCallback, useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router-dom"
import qs from "qs"

import server from "server/serverController2"
import { formatPhoneNumber, formatPriceByLocale, formatDate } from "utils/utils"

import {
  OrderInvoiceTitle,
  OrderInvoiceNotice,
  OrderInvoicePriceDetail,
  OrderInvoiceTotalPrice,
  OrderInvoiceButton,
  OrderInvoiceTop,
  OrderInvoiceBottom,
} from "components/presenters/commerce/order/OrderInvoice"
import {
  OrderDetailTitle,
  OrderInfoTable,
  OrderInfoTableRow,
  BottomButton,
} from "components/presenters/commerce/order/OrderDetail"
import OrderItem from "components/presenters/commerce/order/OrderItem"

import SplitterBar from "components/presenters/common/SplitterBar"
import OrderItemHeader from "components/presenters/commerce/order/OrderItemHeader"

export default function OrderInvoice({ orderNo }) {
  const [orderData, setOrderData] = useState(null)
  const [isShowAuthNotice, setIsShowAuthNotice] = useState(false)

  const history = useHistory()

  const loadOrderData = useMemo(async () => {
    try {
      const form = {}
      form.is_show_shipping_data = true
      form.is_show_payment_data = true
      form.show_order_items = true

      const queryString = qs.stringify(form)
      const response = await server.getRequestData(`commerce/orders/${orderNo}?${queryString}`)
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData
      }
      const { order } = response.data

      return order
    } catch (error) {
      console.log(error)
    }
  }, [orderNo])

  const existChallengeItem = useMemo(() => {
    if (orderData !== null) {
      const { order_items: orderItems } = orderData
      for (const orderItem of orderItems) {
        if (orderItem.is_challenge === true) {
          return true
        }
      }
      return false
    }
  }, [orderData])

  const handleSetOrderData = useCallback(async () => {
    const order = await loadOrderData
    setOrderData(order)
  }, [loadOrderData])

  const handleClickOk = () => {
    history.replace(`/mypage`)
  }

  useEffect(() => {
    handleSetOrderData()
  }, [handleSetOrderData])

  useEffect(() => {
    if (orderData !== null) {
      if (existChallengeItem) {
        setIsShowAuthNotice(existChallengeItem)
      }
    }
  }, [existChallengeItem, orderData])

  return (
    <>
      <OrderInvoiceTop>
        <OrderInvoiceTitle />
        {isShowAuthNotice && <OrderInvoiceNotice />}
        <OrderItemHeader
          orderNo={orderData?.no}
          orderDate={formatDate(orderData?.create_date, ".")}
        />
        {Array.isArray(orderData?.order_items) &&
          orderData?.order_items.map((item) => (
            <OrderItem
              key={`order_item_no_${item.no}`}
              isChallenge={item.is_challenge}
              bannerImg={item.product.banner_img}
              title={item.product.title}
              optionName={item.archived_sku.name}
              unitPrice={item.unit_price}
              quantity={item.quantity}
              challengeUnitPrice={item.challenge_unit_price}
            />
          ))}
        <SplitterBar color={"#EFEFEF"} margin={`calc(100vw * (30 / 375)) 0 0 0`} />
        <OrderInvoicePriceDetail
          subTotal={orderData?.subtotal}
          shippingPrice={orderData?.total_shipping}
        />
        <SplitterBar color={"#EFEFEF"} />
        <OrderInvoiceTotalPrice totalPrice={orderData?.total_price} />
      </OrderInvoiceTop>
      <OrderInvoiceBottom>
        <OrderDetailTitle />
        <OrderInfoTable title={"배송지 정보"} marginBottom={"calc(100vw * (52 / 375))"}>
          <SplitterBar margin={"0 0 calc(100vw * (20 / 375)) 0"} color={"#E5E5E5"} />
          <OrderInfoTableRow name={"받는 사람"} value={orderData?.recipient} />
          <OrderInfoTableRow name={"연락처"} value={formatPhoneNumber(orderData?.phone)} />
          <OrderInfoTableRow
            name={"주소"}
            value={`${orderData?.address1}\n${orderData?.address2}`}
          />
          <OrderInfoTableRow name={"배송메모"} value={orderData?.shipping_action} />
        </OrderInfoTable>
        <OrderInfoTable title={"결제 정보"} marginBottom={"calc(100vw * (36 / 375))"}>
          <SplitterBar margin={"0 0 calc(100vw * (20 / 375)) 0"} color={"#E5E5E5"} />
          <OrderInfoTableRow
            name={"상품 금액"}
            value={`${formatPriceByLocale("ko", orderData?.subtotal)}원`}
          />
          <OrderInfoTableRow
            name={"배송비"}
            value={`(+) ${formatPriceByLocale("ko", orderData?.total_shipping)}원`}
          />
          <OrderInfoTableRow
            name={"결제금액"}
            value={`${formatPriceByLocale("ko", orderData?.total_price)}원`}
          />
          <OrderInfoTableRow name={"결제방법"} value={"카드"} />
          <OrderInfoTableRow name={"주문자"} value={orderData?.recipient} />
          <OrderInfoTableRow name={"연락처"} value={formatPhoneNumber(orderData?.phone)} />
        </OrderInfoTable>
        <BottomButton />
        <OrderInvoiceButton onClick={handleClickOk} />
      </OrderInvoiceBottom>
    </>
  )
}
